<template>
  <div class="container-fluid max-container">
    <div class="row">
      <Header />
      <section>
        <div class="container">
          <div class="archaic-upgrade-container-fluid">
            <!-- BreadCrumb component starts here -->

            <nav class="mt-4" style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item" aria-current="page">
                  <router-link :to="{ name: 'dashboard' }">Home</router-link>
                </li>
                <li class="breadcrumb-item" aria-current="page">
                  <router-link :to="{ name: 'bloodTest' }">Blood Test</router-link>
                </li>
                <li class="breadcrumb-item">
                  <router-link :to="{ name: 'bloodTest' }">{{ selectedBloodTests.name }}</router-link>
                </li>
                <li class="breadcrumb-item">
                  <router-link :to="`/kidney/electrolytes/${selectedBloodTests.barcode}/${route.params.panel}`">{{
                    route.params.panel }}</router-link>
                </li>
                <li class="breadcrumb-item active">Blood test result
                </li>
              </ol>
            </nav>
            <div class="prev-button">
              <router-link :to="`/kidney/electrolytes/${selectedBloodTests.barcode}/${route.params.panel}`">
                <img src="@/assets/images/back-arrow.svg" />
                <span>Back</span>
              </router-link>
            </div>
            <!-- BreadCrumb Component ends here -->

            <!-- Blood Test Component starts here -->
            <div class="blood-test-wrapper-container">
              <h1>{{ patientStore.patient.firstName }}, your blood test result</h1>

              <div class="urea-container row align-items-center">
                <div class="col-lg-7">
                  <h3>{{ markerDetails.Biomarker }}</h3>
                  <p v-html="markerDetails.all_about_body">
                  </p>
                </div>
                <div class="col-lg-5">
                  <AppImage :public-id="markerDetails.potential_symptoms_body_image" :width="widths" />
                </div>
              </div>

              <div class="list-report-grid-row d-flex">
                <div>
                  <!-- <div>
                    <img :src="BloodTestIcon" alt="" />
                  </div> -->
                </div>
                <div>
                  <h3 class="mb-4">{{ markerDetails.potential_symptoms_title }}</h3>
                  <p v-html="markerDetails.potential_symptoms_body" class="mt-4"></p>
                </div>
              </div>
            </div>
            <!-- Blood Test Component ends here -->

            <!-- Urea Levels component starts here -->
            <div class="urea-level-wrapper-row">
              <h3 class="mb-4"> {{ markerDetails.action_header }}</h3>
              <div class="row">
                <div :class="markerDetails.advice_image_2 ? 'col-lg-4 col-md-6' : 'col-12'"
                  v-if="markerDetails.advice_image_1 && markerDetails.advice_title_1 && markerDetails.advice_body_1">
                  <div :class="['card-row-container', { 'horizontal-card': !markerDetails.advice_image_2 }]">
                    <AppImage :public-id="markerDetails.advice_image_1" />
                    <div>
                      <h4>{{ markerDetails.advice_title_1 }}</h4>
                      <p v-html="markerDetails.advice_body_1"></p>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6"
                  v-if="markerDetails.advice_image_2 && markerDetails.advice_title_2 && markerDetails.advice_body_2">
                  <div class="card-row-container">
                    <AppImage :public-id="markerDetails.advice_image_2" />
                    <h4>{{ markerDetails.advice_title_2 }}</h4>
                    <p v-html="markerDetails.advice_body_2">
                    </p>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6"
                  v-if="markerDetails.advice_image_3 && markerDetails.advice_title_3 && markerDetails.advice_body_3">
                  <div class="card-row-container">
                    <AppImage :public-id="markerDetails.advice_image_3" />
                    <h4>{{ markerDetails.advice_title_3 }}</h4>
                    <p v-html="markerDetails.advice_body_3">
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <!-- Urea Levels component ends here -->

            <!-- Cab Cause Component starts here -->
            <div class="cab-cause-wrapper">
              <h3>{{ markerDetails.factors_affecting_title }}</h3>
              <div class="row">
                <div class="col-lg-12 col-md-12">
                  <div class="cab-cause-content-row">
                    <div class="cab-cause-grid-row">
                      <div class="bottom-des" v-html="currentComponent">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Cab Cause Component ends here -->
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script setup>
import Header from "@/components/header/Header.vue";
import "../../../styles/pages/BloodTestResult.scss";
//import BloodTestIcon from "../../../assets/images/Health/Immunity.png";
import { getMarkerDetails } from "@/store/marker";
import { useRoute } from "vue-router";
import { ref, computed } from "vue";
import { usePatientStore } from "@/store/health/blood";

const patientStore = usePatientStore();
const widths = ref(window.visualViewport.width - 110);

const route = useRoute();
const selectedBloodTests = computed(() => patientStore.selectedBloodTest);
console.log('const', selectedBloodTests)

const markerDetails = getMarkerDetails(route.params.marker);
const errorMessage = ref("");
if (!markerDetails) {
  errorMessage.value = "No marker found";
}

const currentComponent = computed(() => {
  return markerDetails.factors_affecting_body
    .replaceAll(
      '<img src="">',
      ``
    )
    .replaceAll('<br>', '<span class="block mb-16"></span>');
  //<img src="${BloodTestIcon}" alt="Blood Test Icon" style="width: 66px; height: 66px;">
});
// function goBack() {
//   router.go(-1);
// }
</script>
